<template>
  <div>
    <el-dialog
        :title="title + '字典'"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        width="20%"
        >
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" :rules="rules">
        <el-form-item label="字典名称：" prop="dictName">
          <el-input v-model.trim="ruleForm.dictName" maxlength="20" placeholder="请输入字典名称"></el-input>
        </el-form-item>
        <el-form-item label="字典代码：" prop="dictKey">
          <el-input v-model.trim="ruleForm.dictKey" maxlength="20" placeholder="请输入字典代码"></el-input>
        </el-form-item>
        <el-form-item label="状态：" prop="isEnabled">
          <el-switch v-model.trim="ruleForm.isEnabled" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm">重新填写</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: '添加',
      dialogVisible: false,
      ruleForm: {
        id: '',
        dictName: '',
        dictKey: '',
        isEnabled: 1,
      },
      rules: {
        dictName: [
          { required: true, message: '请输入字典名称', trigger: 'change' },
        ],
        dictKey: [
          { required: true, message: '请输入字典代码', trigger: 'change' },
        ],
      }
    }
  },
  methods: {
    open(row) {
      Object.assign(this.$data,this.$options.data());
      if( row ) {
        this.title = '修改';
        Object.keys(this.ruleForm).forEach( k => this.ruleForm[k] = row[k])
      }
      this.dialogVisible = true;
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) =>{
        if(valid) {
          this.$axios.post(`/Crm/Dictionary/${ this.title === '添加'?'Add':'Modify' }Dictionary`,this.ruleForm).then(() => {
            this.$emit('complete')
            this.$message.success(`${ this.title }成功`);
            this.dialogVisible = false;
          })
        }
      })
    },
    resetForm() {
      this.ruleForm.dictName = '';
      this.ruleForm.dictKey = '';
      this.ruleForm.isEnabled = 1;
    }
  }
}
</script>

<style scoped>

</style>